import { ProductImageRendition } from "@omni/types/api/product/shared/enums/productImageRendition.enum";

import { ConfigurableProductRenditions } from "@/components/Product/ProductImage/mappedRenditions";
import { ProductImageContainer } from "@/components/Product/ProductImage/productImage.container";

export type ConfigurableProductImageComponentProps = {
    title?: string;
    imageUrl?: string;
};

export const ConfigurableProductImageComponent = ({
    title,
    imageUrl = ""
}: ConfigurableProductImageComponentProps) => {
    return (
        <ProductImageContainer
            title={title}
            medias={[
                {
                    url: imageUrl,
                    format: ProductImageRendition.SM,
                    altText: title
                }
            ]}
            renditions={ConfigurableProductRenditions}
            isEcoChequesAccepted={false}
        />
    );
};
